import React from "react";
import Categories from "./Categories.jsx";
import "./NewsItem.css";

export default function NewsItem() {
  return (
    <div className="container animate__animated animate__slideInLeft">
      <Categories />
      <div className="news-list">
        <div className="news-item">
          <div className="news-image">
            <div className="image-sahur">Sahur Meluncur</div>
          </div>
          <div className="news-content">
            <h3 className="news-paragraf">
              Membangunkan orang puasa untuk sahur menyebabkan kerusuhan
            </h3>
            <p>Mon, 17/09/2022</p>
          </div>
        </div>
        <div className="news-item">
          <div className="news-image">
            <div className="image-sahur">Sahur Meluncur</div>
          </div>
          <div className="news-content">
            <h3 className="news-paragraf">
              Membangunkan orang puasa untuk sahur menyebabkan kerusuhan
            </h3>
            <p>Mon, 17/09/2022</p>
          </div>
        </div>
        <div className="news-item">
          <div className="news-image">
            <div className="image-sahur">Sahur Meluncur</div>
          </div>
          <div className="news-content">
            <h3 className="news-paragraf">
              Membangunkan orang puasa untuk sahur menyebabkan kerusuhan
            </h3>
            <p>Mon, 17/09/2022</p>
          </div>
        </div>
        <div className="news-item">
          <div className="news-image">
            <div className="image-sahur">Sahur Meluncur</div>
          </div>
          <div className="news-content">
            <h3 className="news-paragraf">
              Membangunkan orang puasa untuk sahur menyebabkan kerusuhan
            </h3>
            <p>Mon, 17/09/2022</p>
          </div>
        </div>
        <div className="news-item">
          <div className="news-image">
            <div className="image-sahur">Sahur Meluncur</div>
          </div>
          <div className="news-content">
            <h3 className="news-paragraf">
              Membangunkan orang puasa untuk sahur menyebabkan kerusuhan
            </h3>
            <p>Mon, 17/09/2022</p>
          </div>
        </div>
        <div className="news-item">
          <div className="news-image">
            <div className="image-sahur">Sahur Meluncur</div>
          </div>
          <div className="news-content">
            <h3 className="news-paragraf">
              Membangunkan orang puasa untuk sahur menyebabkan kerusuhan
            </h3>
            <p>Mon, 17/09/2022</p>
          </div>
        </div>
      </div>
    </div>
  );
}
